export default __webpack_public_path__ + "static/media/cerro_de_las_rosas.e6e60183.jpg";